import React, { useState } from 'react';
import { Alert, Box, Card, CardContent, Tab, Tabs } from '@mui/material';
import { useAccessControl } from '../../hooks/useAccessControl';
import { RESOURCES, ACTIONS } from '../../hooks/usePermissions';
import ModulePageHeader from '../common/ModulePageHeader';
import ConfigSection from './ConfigSection';
import { configDescriptors } from './configSections';
import ExpenseClaimsTab from './expenses/ExpenseClaimsTab';
import ExpenseReimbursementsTab from './expenses/ExpenseReimbursementsTab';
import ExpenseRecurringTab from './expenses/ExpenseRecurringTab';
import ExpenseReportsView from './expenses/ExpenseReportsView';

const TABS = [
  { value: 'claims', label: 'Claims', render: () => <ExpenseClaimsTab /> },
  { value: 'reimbursements', label: 'Reimbursements', render: () => <ExpenseReimbursementsTab /> },
  { value: 'categories', label: 'Categories', render: () => <ConfigSection descriptor={configDescriptors.expenseCategories} /> },
  { value: 'recurring', label: 'Recurring', render: () => <ExpenseRecurringTab /> },
  { value: 'reports', label: 'Reports', render: () => <ExpenseReportsView /> },
];

// Expenses: employee expense claims and their reimbursement, plus
// recurring operational expenses and a spend-by-category report
// (config/ledger.php section 'expenses'). A claim records what an
// employee spent and gets approved; a reimbursement is the actual payout
// and is what posts to the GL.
const Expenses = () => {
  const { can } = useAccessControl();
  const [tab, setTab] = useState('claims');

  if (!can(RESOURCES.LEDGER.EXPENSES, ACTIONS.READ)) {
    return <Alert severity="error">You do not have permission to view Expenses.</Alert>;
  }

  const active = TABS.find((t) => t.value === tab);

  return (
    <Box>
      <ModulePageHeader
        title="Expenses"
        subtitle="Employee expense claims, reimbursements, categories and recurring expenses"
      />
      <Card sx={{ mb: 3 }}>
        <CardContent sx={{ pb: '8px !important', pt: '4px !important' }}>
          <Tabs value={tab} onChange={(_, v) => v && setTab(v)} variant="scrollable" scrollButtons="auto">
            {TABS.map((t) => (
              <Tab key={t.value} value={t.value} label={t.label} />
            ))}
          </Tabs>
        </CardContent>
      </Card>

      {active && active.render()}
    </Box>
  );
};

export default Expenses;
